import { useEffect } from 'react';
import s from './ArStep1.module.scss';
import QRCode from 'qrcode.react';
import { useArExport } from '../../../modules/ar-module/hooks/useArExport';

const STATUS_MESSAGES: Record<string, string> = {
  waiting: 'Connecting to 3D engine…',
  exporting: 'Exporting 3D model…',
  optimizing: 'Optimizing for AR…',
};

export const ArStep1 = () => {
  const { isLoading, isIOS, qrValue, iosArUrl, status, trigger } = useArExport();

  // Start export automatically when modal opens
  useEffect(() => {
    trigger();
  }, []);

  const statusMessage = STATUS_MESSAGES[status] || '';

  return (
    <>
      {/* Desktop view */}
      <div className={s.desktop__wrapper}>
        <div className={s.desktop_title}>View in Your Space</div>

        {isLoading && !qrValue && (
          <>
            <div className={s.spinner} />
            <div className={s.desktop_subtitle}>{statusMessage}</div>
          </>
        )}

        {qrValue && (
          <>
            <QRCode value={qrValue} size={200} />
            <div className={s.desktop_subtitle}>
              Scan with your phone to view in AR
            </div>
            <div className={s.desktop_hint}>
              AR will open automatically on your device
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <div className={s.desktop_subtitle}>Failed to generate AR</div>
            <button className={s.btn_next} onClick={trigger}>
              Try again
            </button>
          </>
        )}
      </div>

      {/* Mobile view */}
      <div className={s.wrapper}>
        {/* Status message — hide once iOS button is ready */}
        {isLoading && !iosArUrl && (
          <>
            <div className={s.spinner} />
            <div className={s.subtitle}>{statusMessage}</div>
          </>
        )}

        {/* iOS: show AR button as soon as blob URL is ready (don't wait for server) */}
        {isIOS && iosArUrl && (
          <a className={s.btn_next} rel="ar" href={iosArUrl}>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=="
              style={{ width: 1, height: 1 }}
            />
            Open in AR
          </a>
        )}

        {/* Android: show button when done */}
        {!isIOS && status === 'done' && (
          <button className={s.btn_next} onClick={() => {
            const configurator = (window as any).configurator;
            if (configurator) configurator.downloadGLB();
          }}>
            Open in AR
          </button>
        )}

        {/* QR code — shows when ready, even while server is still processing for iOS */}
        {qrValue && (
          <div className={s.qr_section}>
            <QRCode value={qrValue} size={150} />
            <div className={s.subtitle}>
              Or scan to open on another device
            </div>
          </div>
        )}

        {/* QR still loading indicator for mobile (after AR button is shown) */}
        {iosArUrl && !qrValue && status !== 'error' && (
          <div className={s.qr_section}>
            <div className={s.spinner} />
            <div className={s.subtitle}>Generating QR code…</div>
          </div>
        )}

        {status === 'error' && !iosArUrl && (
          <>
            <div className={s.subtitle}>Failed to generate AR</div>
            <button className={s.btn_next} onClick={trigger}>
              Try again
            </button>
          </>
        )}
      </div>
    </>
  );
};
